module.exports = __webpack_public_path__ + "static/media/99gal54.0fc4512d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal54.jpg
// module id = 253
// module chunks = 0